import React, { Component } from "react";
import FormElement from "../../forms/form_element";
import { Field, reduxForm } from "redux-form";
import { Row, Col, Button } from "react-bootstrap";
import { seedcastForm } from "../../../lib/forms";
import { distributionKeyNames, distributionKeys } from "../../../constants/distribution";
import { If, classNames } from "react-extras";
import FormDropdown from "../../lib/form_dropdown";
import "./distribution_form.scss";
import Divider from "../../lib/divider";
import LoadingButton from "../../forms/loading_button/loading_button";
import { matchPath, withRouter } from "react-router";
import ExternalLink from "../../lib/external_link";
import get from "lodash/get";
class DistributionForm extends Component {
  getShowUUID = () => {
    const paths = matchPath(this.props.location.pathname, {
      path: "/shows/:showUUID",
    });
    return paths.params.showUUID;
  };
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Row>
          <Col xs={12}>
            <div className="distributions-modal-intro">
              To help users find your podcast, you need to distribute it out to various podcast
              platforms. Set up your show on all of these platforms and let us know where they can
              be found below.
            </div>
          </Col>
        </Row>
        {distributionKeys.map(item => this.formRow(item))}
        <Row>
          <Col xs={12}>
            <p className="distributions-modal-outtro">
              There's a few other places you can distribute your podcast to, check out{" "}
              <ExternalLink
                href="https://support.redcircle.com/distributing-your-podcast/distributing-your-podcast-to-other-directories"
                target="_blank"
                rel="noopener noreferrer">
                this article
              </ExternalLink>{" "}
              for more ways to get your podcast out to the world.
            </p>
          </Col>
        </Row>
      </form>
    );
  }

  formRow(row) {
    const { key, name, image, Instructions, placeholder, disabled } = row;
    let value = this.props.getDistributionFormValue(key);
    let completed;
    if (key === distributionKeyNames.youtube) {
      completed = !!get(this.props.shows[this.getShowUUID()], "youtubeAuthToken");
    } else {
      completed = !!value;
    }
    return (
      <div key={key}>
        <Row className="distribution-form-row" key={"distribution-form-row-" + key}>
          <Col md={1} className="hidden-xs hidden-sm distribution-form-row__image-wrapper">
            <img
              alt="service logo"
              src={image}
              className={classNames(
                "distribution-form-row__image",
                completed && "distribution-form-row__image--complete"
              )}
            />
          </Col>
          <Col md={11} xs={12}>
            <If condition={Boolean(Instructions)}>
              <FormDropdown label={name}>
                <div className="distribution-form-instructions">
                  <Instructions showUUID={this.getShowUUID()} />
                </div>
                <If condition={!row.noInput}>
                  <div className="distribution-form-row__input-container">
                    <Field
                      component={FormElement}
                      name={key}
                      type="text"
                      readOnly={disabled}
                      validationErrors={this.props.validationErrors}
                      onFocus={e => e.target.select()}
                      placeholder={placeholder}
                      validationErrorKeyOverride={"links." + key}
                    />
                    <If condition={!disabled}>
                      <LoadingButton
                        Button={Button}
                        className="btn-primary"
                        isLoading={this.props.isPutting}
                        type="submit">
                        Save
                      </LoadingButton>
                    </If>
                  </div>
                </If>
              </FormDropdown>
            </If>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={11} mdOffset={1}>
            <Divider smallMargin />
          </Col>
        </Row>
      </div>
    );
  }
}

let DistributionReduxForm = reduxForm({
  form: "distribution-form",
})(withRouter(DistributionForm));
DistributionReduxForm = seedcastForm(DistributionReduxForm);

export default DistributionReduxForm;
